// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var DragDrop = function DragDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.875 5.625a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m0 6.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M8.75 16.25a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m4.375-10.625a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M15 10a1.875 1.875 0 1 0-3.75 0A1.875 1.875 0 0 0 15 10m-1.875 8.125a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75"
  }));
};
